type TrackPayload = Record<string, string | number | undefined>;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

/**
 * Fires an outbound-click event to whichever analytics layer is present.
 * Safe no-op during SSR or when no analytics is installed.
 */
export function trackOutboundClick(label: string, href: string, extra: TrackPayload = {}) {
  if (typeof window === "undefined") return;

  const payload = {
    event_category: "outbound",
    event_label: label,
    link_url: href,
    link_type: href.startsWith("mailto:") ? "email" : "link",
    ...extra,
  };

  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", "cta_click", payload);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: "cta_click", ...payload });
    }
  } catch {
    // analytics must never break navigation
  }
}
